// Utils
import { asyncResource } from '../../utils/services/http/asyncResource/asyncResource';
import { fetchCurrentUserGoogleContacts } from './googleService';
import { hasGoogleScope } from '../../../common/users/utils/userPropertyUtils';

// Selectors
import { getCurrentUser } from '../currentUserSelector';

// Constants
import { GOOGLE_SCOPES } from '../../../common/utils/googleUtils';
import { CONTACT_TYPES } from '../contacts/userContactsConstants';
import { ResourceTypes } from '../../utils/services/http/asyncResource/asyncResourceConstants';

export const getCurrentUserGoogleContacts =
    ({ force = false }) =>
    (dispatch, getState) => {
        const state = getState();

        // If the current user doesn't have the correct scope then don't even try to fetch the contacts
        const currentUser = getCurrentUser(state);

        if (!hasGoogleScope(currentUser, GOOGLE_SCOPES.contacts_read_only)) return;

        return dispatch(
            asyncResource(ResourceTypes.contacts, CONTACT_TYPES.GOOGLE, force)(fetchCurrentUserGoogleContacts),
        );
    };
